import { useSelector } from 'react-redux';

import { AnalyticsAction } from 'lib/analytics/constants';
import store from 'store';

import { useAskKlue } from '../use-ask-klue';

import type { AskKlueEvent } from 'hooks/dashboard/use-ask-klue-log/useAskKlueLog';

const selectAllRivals = store.select(({ rivals: { all } }) => ({
  allRivals: all,
}));

const useAskKlueSupportedRival = () => {
  const { handleAskKlue } = useAskKlue();
  const { allRivals } = useSelector(selectAllRivals);

  // Returns true when the input matches a supported rival and the profile
  // tab was opened — callers should early-return so the input isn't also
  // submitted as a chat question. Exposed so modern chat paths (which
  // bypass handleAskKlue entirely) can preserve this behaviour.
  const tryOpenSupportedRival = (input: string): boolean => {
    const lowercaseName = input.toLocaleLowerCase();
    const supportedRival = allRivals?.find(
      (rival) =>
        rival.name.toLocaleLowerCase() === lowercaseName &&
        rival.supportedRivalId &&
        rival.profileId,
    );

    if (supportedRival) {
      window.open(
        `/company/${supportedRival.supportedRivalId}/profile/${supportedRival.profileId}`,
        '_blank',
      );
      return true;
    }
    return false;
  };

  const handleAskKlueInput = (
    input: string,
    logEventType: AskKlueEvent['type'] = AnalyticsAction.ask,
  ) => {
    if (tryOpenSupportedRival(input)) return;
    handleAskKlue(input, logEventType);
  };

  return { handleAskKlueInput, tryOpenSupportedRival };
};

export default useAskKlueSupportedRival;
